export default {
  "content": "<path d=\"M0 0h48v48H0V0z\" fill=\"none\"/><path fill=\"#20944E\" d=\"M24 0C10.8 0 0 10.8 0 24s10.8 24 24 24 24-10.8 24-24S37.2 0 24 0zm0 46C11.9 46 2 36.1 2 24S11.9 2 24 2s22 9.9 22 22-9.9 22-22 22z\"/><path fill=\"#20944E\" d=\"M24 4C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4zm0 38c-9.9 0-18-8.1-18-18S14.1 6 24 6s18 8.1 18 18-8.1 18-18 18z\"/><path fill=\"#20944E\" d=\"M20.5 29.6l-3.8-3.1-1.3 1.5 5.4 4.3 12-14.7-1.5-1.3-10.8 13.3z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "48",
    "height": "48"
  }
};